// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v717demo1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'https://ibtc-cms.ripple-digital.com/api',
  webUrl: 'https://ibtc-cms.ripple-digital.com/storage',
  // apiUrl: 'https://cms.ibtc.co.za/api',
  // webUrl: 'https://cms.ibtc.co.za/storage',
  catalsytSystemID: 'IBTC',
  // catalsytSystemID: 'IBTCTest',
  catalystURL: 'https://catalyst.viadata.co.za/webservice/service.aspx',
  // catalystURL: 'https://dev.viadata.co.za/webservice/service.aspx',
  GTM_ID: '',
  PP_url: 'https://test.oppwa.com',
  NOINDEX: true,
};

/*
export const environment = {
  production: false,
  appVersion: 'v717demo1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  apiUrl: 'http://localhost:8000/api',
  webUrl: 'http://localhost:8000/storage',
  catalsytSystemID: 'IBTC',
  catalystURL: 'https://dev.viadata.co.za/webservice/service.aspx',
  GTM_ID: 'GTM-5QSJH56'
};
*/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
